<template>
  <div>
    <form
      v-bind:class="{
        'o-form': true,
        'o-form--sidebar-program-search': isOnResultsPage,
      }"
    >
      <fieldset
        class="o-form__section s-content-block s-content-block--small"
        id="DegreePartnershipForm"
      >
        <h4>Degree Partnerships Search</h4>
        <div v-if="!isOnResultsPage">
          <div v-html="searchHeaderContent"></div>
        </div>

        <!-- Credential -->
        <div class="m-field-group m-field-group--contain">
          <label for="">Credential</label>
          <select v-model="filter.credentialId">
            <option :value="null" selected>All Credentials...</option>
            <option v-for="credential in credentials" :key="credential.id" :value="credential.id">
              {{ credential.name }}
            </option>
          </select>
        </div>

        <!-- Institution -->
        <div class="m-field-group m-field-group--contain">
          <label for="">Institution</label>
          <select v-model="filter.institutionId">
            <option :value="null" selected>All Institutions</option>
            <option
              v-for="institution in institutions"
              :key="institution.id"
              :value="institution.id"
            >
              {{ institution.code }} - {{ institution.name }}
            </option>
          </select>
        </div>
      </fieldset>

      <button type="button" class="a-button" @click="submitSearch">Search</button>
    </form>
  </div>
</template>

<script setup>
import { ref, reactive, watch, onMounted, computed } from 'vue'
import { defineProps, defineEmits, defineExpose } from 'vue'
import axios from 'axios'
import _ from 'lodash'

const degreePartnershipsSearchFilterDataStorageName = 'degree-partnerships-search-params'

const props = defineProps({
  nonce: { type: String, required: true },
  basePagePath: { type: String, default: false },
  resultsPagePath: { type: String, default: false },
  isOnResultsPage: { type: Boolean, default: false },
  searchHeaderContent: { type: String, required: true },
  apiUrls: { type: Object, required: true },
})

const emit = defineEmits(['onSubmit'])

const filter = ref({
  credentialId: null,
  institutionId: null,
})

const institutions = ref([])
const credentials = ref([])

const getCredentials = async () => {
  const response = await axios.get(props.apiUrls.searchCustomBaseURL + 'dp/GetProvCredentials')
  credentials.value = _.sortBy(response.data, 'name')
}

const getInstitutions = async () => {
  const response = await axios.get(props.apiUrls.searchCustomBaseURL + 'dp/GetInstitutions')
  institutions.value = _.sortBy(response.data, 'name')
}

const updatePersistence = () => {
  sessionStorage.setItem(
    degreePartnershipsSearchFilterDataStorageName,
    JSON.stringify(filter.value),
  )
}

const clearPersistence = () => {
  sessionStorage.removeItem(degreePartnershipsSearchFilterDataStorageName)
}

const newSearch = () => {
  clearPersistence()
  window.location.href = props.basePagePath
}

const submitSearch = () => {
  updatePersistence()

  if (!props.isOnResultsPage) {
    window.location = props.resultsPagePath
    return
  }

  submit()
}

const submit = () => {
  emit('onSubmit', filter.value)
}

onMounted(() => {
  getCredentials()
  getInstitutions()

  if (props.isOnResultsPage) {
    submit()
  }
})

watch(filter, updatePersistence, { deep: true })

let filterDataLocalStorage = sessionStorage.getItem(degreePartnershipsSearchFilterDataStorageName)
if (_.isString(filterDataLocalStorage)) {
  filterDataLocalStorage = JSON.parse(filterDataLocalStorage)
} else {
  filterDataLocalStorage = {}
}

_.forEach(filterDataLocalStorage, (value, key) => {
  if (!_.isNull(value)) {
    _.set(filter.value, key, value)
  }
})

defineExpose({
  newSearch,
})
</script>
